import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  GraduationCap,
  HeartHandshake,
  Github,
  Twitter,
  Linkedin,
  Shield,
  FileText,
} from 'lucide-react';
import { SUPPORT_EMAIL, NAV_LINKS, MODULES, scrollToSection } from './landingData';

export default function LandingFooter() {
  const navigate = useNavigate();

  return (
    <footer className="mt-14 border-t border-white/10 pt-10 pb-6">
      <div className="grid gap-8 md:grid-cols-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-blue-500/30 bg-blue-600/20">
              <GraduationCap className="h-5 w-5 text-blue-400" />
            </div>
            <div>
              <p className="font-semibold text-white">School Analytics</p>
              <p className="text-xs text-white/50">School management system</p>
            </div>
          </div>
          <p className="mt-4 text-sm text-white/50">
            A complete school ERP for admins, teachers and students with mobile-ready experience.
          </p>

          <div className="mt-5 flex items-center gap-2 text-white/60">
            <a
              className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 transition-colors hover:bg-white/10 hover:text-white"
              href="https://github.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <Github className="h-4 w-4" />
            </a>
            <a
              className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 transition-colors hover:bg-white/10 hover:text-white"
              href="https://twitter.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <Twitter className="h-4 w-4" />
            </a>
            <a
              className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 transition-colors hover:bg-white/10 hover:text-white"
              href="https://linkedin.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="text-sm md:col-span-2">
          <p className="font-semibold text-white">Quick links</p>
          <div className="mt-3 grid gap-2 text-white/50">
            <button
              type="button"
              className="text-left transition-colors hover:text-white"
              onClick={() => navigate('/login')}
            >
              Login
            </button>
            <button
              type="button"
              className="text-left transition-colors hover:text-white"
              onClick={() => navigate('/register')}
            >
              Register
            </button>
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                type="button"
                className="text-left transition-colors hover:text-white"
                onClick={() => scrollToSection(link.id)}
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>

        <div className="text-sm md:col-span-3">
          <p className="font-semibold text-white">Modules</p>
          <div className="mt-3 grid grid-cols-2 gap-2 text-white/50">
            {MODULES.slice(0, 10).map((m) => (
              <span key={m.title} className="truncate" title={m.title}>
                {m.title}
              </span>
            ))}
          </div>
        </div>

        <div className="text-sm md:col-span-3">
          <p className="font-semibold text-white">Support</p>
          <div className="mt-3 grid gap-2 text-white/50">
            <a className="transition-colors hover:text-white" href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>
            <p>Powered by CP Rawat Software Services</p>
            <div className="flex items-start gap-2">
              <HeartHandshake className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" />
              <p>For onboarding, demo and access requests, use the contact form above.</p>
            </div>
            <div className="mt-1 grid gap-2 text-xs text-white/40">
              <a className="inline-flex items-center gap-2 hover:text-white/70" href="#/privacy">
                <Shield className="h-3.5 w-3.5" /> Privacy Policy
              </a>
              <a className="inline-flex items-center gap-2 hover:text-white/70" href="#/terms">
                <FileText className="h-3.5 w-3.5" /> Terms
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 text-xs text-white/40">
        <p>© {new Date().getFullYear()} CP Rawat Software Services. All rights reserved.</p>
      </div>
    </footer>
  );
}
